import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Client from "../../entity/emergency/Client";
import useEmergencyInterventionDemo
    from "../../component/private/intervention/emergency/demo/useEmergencyInterventionDemoServer";

const SERVICE = "service-emergency";
const ENTITY = "clients";

/**
 * @rule-checker exclude
 * @returns {*|void|boolean|{select(): (null|*), exec(): (undefined|*|void|null|boolean|undefined)}|{findOneById(*): {select(): (null|*), exec(): (undefined|*|void|null|boolean|undefined)}, findOneByOrderId(*): {select(): (null|*), exec(): (undefined|*|void|null|boolean|undefined)}, update(*, *, *): Promise<boolean|undefined>}|Promise<boolean|undefined>|null}
 */
export default function () {
    const {findOneBy, update} = useApi();
    const state = useSelector;
    const newInstance = data => new Client(data);
    const demo = useEmergencyInterventionDemo();

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.emergency?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    if (demo.isLockRequest()) {
                        return demo.handleRequest("GET", SERVICE, ENTITY, "id", id);
                    }

                    findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application_v7");
                }
            }
        },
        findOneByOrderId(id) {
            return {
                select() {
                    const result = state(state => state.api?.emergency?.[ENTITY]?.find(c => c?.getOrderId() == id));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    if (demo.isLockRequest()) {
                        return demo.handleRequest("GET", SERVICE, ENTITY, "order_id", id);
                    }

                    findOneBy(SERVICE, ENTITY, "order_id", id, newInstance, "application_v7");
                }
            }
        },
        async update(id, property, payload) {
            return update(SERVICE, ENTITY, id, property, payload, newInstance, "application_v7");
        }
    }
}